// src/components/chat/sections/dailyOutfit/WeeklyOutfitGenerator.js
import React from 'react';

const WeeklyOutfitGenerator = ({ generateWeeklyOutfits, isLoading }) => {
    const handleGenerateClick = async () => {
        if (isLoading) return;
        await generateWeeklyOutfits();
    };

    return (
        <div className="weekly-generator-container">
            <button 
                className={`weekly-outfit-btn ${isLoading ? 'generating' : ''}`}
                onClick={handleGenerateClick}
                disabled={isLoading}
            >
                {isLoading ? (
                    <>
                        Creating weekly plan
                        <div className="loading-dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </>
                ) : (
                    <>
                        Create Weekly Outfit Plan
                    </>
                )}
            </button>
            <p className="weekly-info">
                This will generate 3 versatile looks valid for 7 days
            </p>
        </div>
    );
};

export default WeeklyOutfitGenerator;